import { render, staticRenderFns } from "./EmojiPickerContainer.vue?vue&type=template&id=3567ec5e&"
import script from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"
export * from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports